import { IProductObject } from '@features/categories/typescript';
import GoogleAdwordsListing from '@reaffiliates/GoogleAdwords/GoogleAdwordsListing';
import GoogleTagManagerItemList from '@reaffiliates/GoogleTagManager/GoogleTagManagerItemList';
import { PRODUCTS_RENDER_COUNTS } from '@features/categories/const';
import CreateProductItems from '@utils/createProductItems';
import { TEvent } from '@typescript/index';
const ReaffiliatesProductListing = (products: IProductObject[], category: string, priceListName: string, count: number, listingType: string, listingId: number, event?: TEvent) => {
  GoogleTagManagerItemList(CreateProductItems(products.slice(count - PRODUCTS_RENDER_COUNTS), category, priceListName), listingType, listingId, event);
  GoogleAdwordsListing(products, category, priceListName);
};
export default ReaffiliatesProductListing;